import { render, staticRenderFns } from "./KeywordsInGDTable.vue?vue&type=template&id=f2643968&scoped=true&"
import script from "./KeywordsInGDTable.vue?vue&type=script&lang=js&"
export * from "./KeywordsInGDTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2643968",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
